import React from 'react';
import { ThemeProvider } from './styles/styled-components';
import { Provider as MobxProvider } from 'mobx-react';
import { theme } from './styles/theme';
import { stores } from './store';

export const Providers: React.SFC<{}> = ({ children }) => (
  <ThemeProvider theme={theme}>
    <MobxProvider {...stores}>{children}</MobxProvider>
  </ThemeProvider>
);
